import { computed, effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalendarAvailabilityService {
  fetchcalendarAvailability = signal<AvailabilitiesType[]>([])

  now = new Date()
  month = signal(this.now.getMonth())
  year = signal(this.now.getFullYear())

  staffSelected = signal<string>('all')
  
  daySelectedAvailability = signal<AvailabilitiesType>({} as AvailabilitiesType)

  readonly mapDate = computed(() => {

    if (this.fetchcalendarAvailability() !== null)
      return new Map<number, StaffAvailability[]>(
        this.fetchcalendarAvailability().map(entry => {
          return [
            entry.date, entry.staffAvailability
          ]
        })
      )
    
    return new Map()
  });
  
  calendar = computed<Calendar>( () => {

    return {
      today: new Date(),
      past: this.month() == new Date().getMonth(),
      firstDay: new Date(this.year(), this.month(), 1),
      dayInMonth: new Date(this.year(), this.month() + 1, 0).getDate(),
      previousMonthDays: new Date(this.year(), this.month(), 0).getDate()
    }
  } )

  calendarDays = computed(() => {
    return Array.from({ length: 35 }, (_, i) => {
      const firstDayIndex = this.calendar().firstDay.getDay(); // 0 (Sun) to 6 (Sat)
      const daysInCurrentMonth = this.calendar().dayInMonth;
      const daysInPrevMonth = new Date(this.year(), this.month(), 0).getDate();
    
      if (i < firstDayIndex) {
        // Fill from previous month
        return `-${daysInPrevMonth - (firstDayIndex - i - 1)}`;
      }
    
      const dayNum = i - firstDayIndex + 1;
    
      if (dayNum > daysInCurrentMonth) {
        // Fill from next month
        return `+${dayNum - daysInCurrentMonth}`;
      }
    
      // Current month
      return `${dayNum}`;
    })
  })

  items = computed( () => {
    const availabilities = this.calendarDays().map(day => {
      let dayOfMonth = Math.abs(+day)
      let month = (['-'].includes(day[0])) ? this.month() : ['+'].includes(day[0]) ? this.month()+2 : this.month()+1
      let year = this.year()

      if (month === -1) {
        month = 12
        year = year-1
      } else if (month === 13) {
        month = 1
        year = year+1
      }

      let availability: StaffAvailability[] = [] as StaffAvailability[]
      if (!['-'].includes(day[0])){
        if (this.mapDate().get(`${month.toString().padStart(2, '0')}-${dayOfMonth.toString().padStart(2, '0')}-${year}`)){
          if(this.calendar().today.getDate() <= Number(day) || ['+'].includes(day[0])){
            availability = this.mapDate().get(`${month.toString().padStart(2, '0')}-${dayOfMonth.toString().padStart(2, '0')}-${year}`)!
          }else if (this.mapDate().get(`${month.toString().padStart(2, '0')}-${dayOfMonth.toString().padStart(2, '0')}-${year}`) !== undefined)
            if(this.mapDate().get(`${month.toString().padStart(2, '0')}-${dayOfMonth.toString().padStart(2, '0')}-${year}`)!.length >0){
              availability = this.mapDate().get(`${month.toString().padStart(2, '0')}-${dayOfMonth.toString().padStart(2, '0')}-${year}`)!
            }
        }
      } 

      return {
        day: dayOfMonth,
        month: month,
        year: year,
        staffAvailability: availability
      }
    })

    return availabilities
  })

  availableTimeSlot = computed<{morning: StaffAvailability[], afternoon: StaffAvailability[]}>( () => {
    if(this.daySelectedAvailability().staffAvailability)
      return {
        morning: this.daySelectedAvailability().staffAvailability.filter(staff => this.staffTimeSlot(staff, (Number(staff.timeSlot) < 1200))),
        afternoon: this.daySelectedAvailability().staffAvailability.filter(staff =>  this.staffTimeSlot(staff, (Number(staff.timeSlot) >= 1200)))
      }
    else
      return {morning: [], afternoon: []}
  } )

  private staffTimeSlot (staff : StaffAvailability, compare: boolean): boolean {
    if( this.staffSelected() === 'all')
      return compare
    else {
      if(staff.staffMembers.filter(staff => staff.staffID.toString() === this.staffSelected()).length && compare)
        return true
    }

    return false

  }

  eff = effect(() => {
    const firstEntry = this.mapDate().entries().next().value;
    if (firstEntry) {
      this.daySelectedAvailability.set({
        year: new Date(firstEntry[0].toString().replaceAll('-','/')).getFullYear(),
        date: new Date(firstEntry[0].toString().replaceAll('-','/')).getDate(),
        month: new Date(firstEntry[0].toString().replaceAll('-','/')).getMonth()+1,
        staffAvailability: firstEntry[1]
      });
    }
  });

}
